import React from 'react';
import { memo } from 'react';
import { Row, Space } from 'antd';
import { PlusCircleOutlined } from '@ant-design/icons';
import { KBEntity, Section } from '../admin-knowledge-base.type';
import Button from '/react4xp/mixins/ui/button/button';
import {
    DndContext,
    DragEndEvent,
    KeyboardSensor,
    PointerSensor,
    closestCenter,
    useSensor,
    useSensors,
} from '@dnd-kit/core';
import {
    SortableContext,
    rectSortingStrategy,
    sortableKeyboardCoordinates,
} from '@dnd-kit/sortable';
import SortableSection from './sortable-section';
import {validatePrivileges} from "mixins/helpers";

interface SectionSelectorProps {
    sections: Section[];
    activeSection: Section;
    selectSection: React.Dispatch<React.SetStateAction<Section>>;
    showUpdateForm: (section: Section) => void;
    showCreateForm: () => void;
    showDeleteForm: (entity: KBEntity) => void;
    handleReorder: (event: DragEndEvent) => void;
    roles: string[];
    privileges: string[];
}

const SectionSelector = memo(
    ({
        sections,
        activeSection,
        selectSection,
        showUpdateForm,
        showCreateForm,
        showDeleteForm,
        handleReorder,
        roles,
        privileges,
    }: SectionSelectorProps) => {
        const sensors = useSensors(
            useSensor(PointerSensor),
            useSensor(KeyboardSensor, {
                coordinateGetter: sortableKeyboardCoordinates,
            })
        );

        const handleDragEnd = (event) => {
            handleReorder(event);
        };

        return (
            <Row
                justify="space-between"
                gutter={[16, 16]}
            >
                <DndContext
                    sensors={sensors}
                    collisionDetection={closestCenter}
                    onDragEnd={handleDragEnd}
                >
                    <SortableContext
                        items={sections.map((item) => item.id)}
                        strategy={rectSortingStrategy}
                    >
                        <Space wrap>
                            {sections.map((section) => (
                                <SortableSection
                                    key={section.id}
                                    section={section}
                                    isActive={section.id === activeSection?.id}
                                    selectSection={selectSection}
                                    showDeleteForm={showDeleteForm}
                                    showUpdateForm={showUpdateForm}
                                    roles={roles}
                                    privileges={privileges}
                                />
                            ))}
                        </Space>
                    </SortableContext>
                </DndContext>
                {validatePrivileges(roles, privileges, 'PRIV_CHAPTER_CREATE') && (
                    <Button
                        icon={<PlusCircleOutlined />}
                        onClick={showCreateForm}
                        ghost
                    >
                        Добавить раздел
                    </Button>
                )}
            </Row>
        );
    }
);

export default SectionSelector;
